/*
 * Checkout Flow — <cf-expertise-scene data-kind="website|app|automation|commerce">
 * Mode standard : la scène avance avec la position de la ligne dans l'écran (défilement natif).
 * Mode séquence (<cf-exp-sequence>, section « immersive ») : une expertise à la fois dans une section
 * fixée ; la séquence pilote la scène active (external) et bascule d'un panneau à l'autre.
 * Les étapes (site, app) sont de vrais boutons : un clic affiche l'étape choisie.
 * Mouvement réduit : état final, étapes consultables au clic.
 */
(() => {
  const start = () => {
    const CF = window.CF;
    if (!CF || customElements.get('cf-expertise-scene')) return;
    const { clamp, seg, lerp, motion, loop, observeVisible, onScroll, scrollTop, scroller, track, live, firstBind, release, whenNear } = CF;
    const locale = (CF.config && CF.config.locale) || document.documentElement.lang || 'en';
    const money = (n) => { try { return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(Math.round(n)); } catch (e) { return Math.round(n) + ' €'; } };
    const fmt = (n) => { try { return Math.round(n).toLocaleString(locale); } catch (e) { return String(Math.round(n)); } };
    const show = (el, o, tf) => { if (!el) return; el.style.opacity = o.toFixed(3); el.style.visibility = o > 0.002 ? 'visible' : 'hidden'; if (tf) el.style.transform = tf; };

    /* ---------- site web ---------- */
    const WEB_STEPS = [0.1, 0.27, 0.45, 0.66, 0.96];
    function web(E, l, t) {
      const step = l < 0.17 ? 0 : l < 0.34 ? 1 : l < 0.54 ? 2 : l < 0.74 ? 3 : 4;
      const enter = seg(l, 0, 0.05);
      const ex = seg(l, 0.55, 0.64) * (1 - seg(l, 0.7, 0.78));
      const settle = seg(l, 0.74, 0.9);
      show(E.wb, enter, `translateZ(${(-120 * (1 - enter)).toFixed(1)}px) rotateX(${(ex * 18 + 4 * settle).toFixed(2)}deg) rotateY(${(-ex * 26 - 10 * settle).toFixed(2)}deg) rotateZ(${(ex * 3).toFixed(2)}deg)`);
      E.grid.style.opacity = (seg(l, 0.02, 0.08) * (1 - seg(l, 0.2, 0.3))).toFixed(3);
      const Z = [150, 90, 40, 70, 100], WI = [0.03, 0.06, 0.09, 0.11, 0.13], FI = [0.2, 0.23, 0.26, 0.28, 0.3];
      for (let k = 0; k < 5; k++) {
        const b = E['b' + k]; if (!b) continue;
        const w = seg(l, WI[k], WI[k] + 0.04), f = seg(l, FI[k], FI[k] + 0.05);
        const wf = b._wf || (b._wf = b.querySelector('.wf')), fl = b._fl || (b._fl = b.querySelector('.fl'));
        wf.style.opacity = (w * (1 - f)).toFixed(3); wf.style.transform = `scale(${lerp(0.88, 1, w).toFixed(3)})`;
        fl.style.opacity = f.toFixed(3); fl.style.transform = `translateY(${(10 * (1 - f)).toFixed(1)}px)`;
        b.style.transform = `translateZ(${(ex * Z[k]).toFixed(1)}px)`;
      }
      const cube = seg(l, 0.28, 0.34);
      E.cw.style.opacity = cube.toFixed(3);
      E.cw.style.transform = `scale(${lerp(0.3, 1, cube).toFixed(3)}) translateZ(${(ex * 70).toFixed(1)}px)`;
      E.cube.style.transform = `rotateX(-18deg) rotateY(${(l * 540 + t * 0.02).toFixed(1)}deg)`;
      const pin = seg(l, 0.15, 0.2), pout = seg(l, 0.34, 0.4);
      show(E.pal, pin * (1 - pout), `translate3d(${(-30 * (1 - pin)).toFixed(1)}px,0,140px)`);
      if (!E._sw) E._sw = [...E.pal.querySelectorAll('i')];
      E._sw.forEach((s, k) => { const a = seg(l, 0.17 + k * 0.02, 0.2 + k * 0.02); s.style.transform = `scale(${lerp(0.2, 1, a).toFixed(3)})`; s.style.opacity = a.toFixed(3); });
      const cin = seg(l, 0.34, 0.38), cout = seg(l, 0.52, 0.56);
      show(E.code, cin * (1 - cout), `translate3d(${(40 * (1 - cin) + 60 * cout).toFixed(1)}px,0,170px) rotateY(-8deg)`);
      if (!E._ln) E._ln = [...E.code.querySelectorAll('.ln')];
      E._ln.forEach((ln, k) => { ln.style.width = `${(seg(l, 0.37 + k * 0.024, 0.395 + k * 0.024) * 100).toFixed(1)}%`; });
      const mv = seg(l, 0.6, 0.68);
      E.cur.style.opacity = (seg(l, 0.58, 0.61) * (1 - seg(l, 0.74, 0.78))).toFixed(3);
      E.cur.style.transform = `translate3d(${lerp(380, 48, mv).toFixed(1)}px,${lerp(250, 168, mv).toFixed(1)}px,${(ex * 110 + 10).toFixed(1)}px)`;
      const hit = l > 0.68;
      if (hit && E._clicked === false) { E.cur.classList.remove('click'); void E.cur.offsetWidth; E.cur.classList.add('click'); }
      if (hit !== E._clicked) { E.cta.classList.toggle('ok', hit); E.cta.textContent = E.cta.getAttribute(hit ? 'data-b' : 'data-a'); E._clicked = hit; }
      const live = l > 0.76;
      if (live !== E._live) { E._live = live; E.url.classList.toggle('live', live); E.urlt.textContent = E.urlt.getAttribute(live ? 'data-live' : 'data-dev'); E.live.classList.toggle('on', live); }
      const g = seg(l, 0.8, 0.9);
      show(E.gauge, g, `translate3d(${(30 * (1 - g)).toFixed(1)}px,0,200px) scale(${lerp(0.8, 1, g).toFixed(3)})`);
      const sc = seg(l, 0.82, 0.95);
      E.arc.style.strokeDashoffset = (213.6 * (1 - 0.98 * sc)).toFixed(1);
      E.score.textContent = String(Math.round(98 * sc));
      const s = seg(l, 0.85, 0.93);
      show(E.serp, s, `translate3d(0,${(30 * (1 - s)).toFixed(1)}px,190px)`);
      const m = seg(l, 0.89, 0.97);
      show(E.mob, m, `translate3d(${(40 * (1 - m)).toFixed(1)}px,0,160px) rotateY(-14deg)`);
      return step;
    }

    /* ---------- application ---------- */
    const APP_STEPS = [0.08, 0.22, 0.33, 0.7, 0.96];
    function fire(E, i, on) {
      E._fired = E._fired || [false, false, false];
      if (on && !E._fired[i]) { const r = E['rp' + (i + 1)]; if (r) { r.classList.remove('go'); void r.offsetWidth; r.classList.add('go'); } }
      E._fired[i] = on;
    }
    function app(E, l, t) {
      const step = l < 0.14 ? 0 : l < 0.26 ? 1 : l < 0.38 ? 2 : l < 0.82 ? 3 : 4;
      E.wrap.style.opacity = seg(l, 0, 0.05).toFixed(3);
      E.ph.style.transform = `scale(.9) rotateY(${lerp(-24, 10, l).toFixed(2)}deg) rotateX(${(5 + Math.sin(t * 0.0008) * 2).toFixed(2)}deg) translateY(${(Math.sin(t * 0.001) * 6).toFixed(1)}px)`;
      const FAN = [[-190, -6, -12], [0, -26, 0], [190, -6, 12]];
      ['w0', 'w1', 'w2'].forEach((k, i) => {
        const a = seg(l, 0.02 + i * 0.025, 0.06 + i * 0.025), f = seg(l, 0.1, 0.16);
        show(E[k], a * (1 - f), `translate3d(${(FAN[i][0] * (1 - f)).toFixed(1)}px,${(FAN[i][1] * (1 - f) + 20 * f).toFixed(1)}px,${lerp(160, 40, f).toFixed(1)}px) rotate(${(FAN[i][2] * (1 - f)).toFixed(1)}deg) scale(${lerp(1, 0.6, f).toFixed(3)})`);
      });
      show(E.wire, seg(l, 0.1, 0.15) * (1 - seg(l, 0.19, 0.23)));
      const bi = seg(l, 0.16, 0.21), bs = seg(l, 0.22, 0.27);
      show(E.big, bi * (1 - bs), `translate3d(${lerp(0, -70, bs).toFixed(1)}px,${lerp(0, -150, bs).toFixed(1)}px,${lerp(200, 60, bs).toFixed(1)}px) scale(${(lerp(0.2, 1, bi) * lerp(1, 0.3, bs)).toFixed(3)}) rotate(${((1 - bi) * -40).toFixed(1)}deg)`);
      const hm = seg(l, 0.2, 0.24), sp = seg(l, 0.39, 0.43), spOut = seg(l, 0.46, 0.49);
      show(E.home, hm * (1 - sp), `scale(${(1 + sp * 0.25).toFixed(3)})`);
      E.me.style.opacity = seg(l, 0.25, 0.28).toFixed(3);
      const bin = seg(l, 0.26, 0.3), bout = seg(l, 0.4, 0.44);
      show(E.bld, bin * (1 - bout), `translate3d(${(40 * (1 - bin)).toFixed(1)}px,0,170px)`);
      const io = seg(l, 0.28, 0.35), an = seg(l, 0.29, 0.36);
      E.iosb.style.width = `${(io * 100).toFixed(1)}%`; E.andb.style.width = `${(an * 100).toFixed(1)}%`;
      E.ios.textContent = `${Math.round(io * 100)} %`; E.and.textContent = `${Math.round(an * 100)} %`;
      E.ok.classList.toggle('on', l > 0.36);
      fire(E, 0, l > 0.37);
      show(E.splash, sp * (1 - spOut), `scale(${lerp(0.25, 1, sp).toFixed(3)})`);
      E.ld.style.width = `${(seg(l, 0.42, 0.48) * 100).toFixed(1)}%`;
      const cat = seg(l, 0.47, 0.51), catOut = seg(l, 0.6, 0.64);
      show(E.cat, cat * (1 - catOut * 0.6), `translateX(${(-35 * catOut).toFixed(1)}%)`);
      E.grid.style.transform = `translateY(${(-110 * seg(l, 0.51, 0.58)).toFixed(1)}px)`;
      fire(E, 1, l > 0.59);
      const pr = seg(l, 0.6, 0.64);
      show(E.prod, pr, `translateX(${(100 * (1 - pr)).toFixed(1)}%)`);
      E.cube.style.transform = `rotateX(-20deg) rotateY(${(l * 420 + t * 0.03).toFixed(1)}deg)`;
      fire(E, 2, l > 0.66);
      const sh = seg(l, 0.67, 0.7);
      show(E.sheet, sh, `translateY(${(100 * (1 - sh)).toFixed(1)}%)`);
      const ok = l > 0.74;
      E.pay.classList.toggle('ok', ok);
      const txt = E.payt.getAttribute(ok ? 'data-c' : (l > 0.71 ? 'data-b' : 'data-a'));
      if (E.payt.textContent !== txt) E.payt.textContent = txt;
      const nt = seg(l, 0.77, 0.82);
      show(E.note, nt, `translateY(${(-80 * (1 - nt)).toFixed(1)}px) scale(${lerp(0.9, 1, nt).toFixed(3)})`);
      const pb = seg(l, 0.82, 0.88);
      show(E.pub, pb, `translate3d(${(40 * (1 - pb)).toFixed(1)}px,0,180px)`);
      const c = seg(l, 0.86, 0.92);
      show(E.pf3, c, `translate3d(${(-30 * (1 - c)).toFixed(1)}px,0,140px)`);
      const d = seg(l, 0.88, 1);
      if (!E._len) { try { E._len = E.pf3l.getTotalLength(); } catch (e) { E._len = 220; } E.pf3l.style.strokeDasharray = E._len; }
      E.pf3l.style.strokeDashoffset = (E._len * (1 - d)).toFixed(1);
      E.pf3n.textContent = money(1248 * d);
      return step;
    }

    /* ---------- automatisation ---------- */
    function automation(E, l) {
      if (!E._nd) { E._nd = [...E.root.querySelectorAll('[data-nd]')]; E._w = [...E.root.querySelectorAll('[data-wire]')]; E._pk = [...E.root.querySelectorAll('[data-pk]')]; }
      E._nd.forEach((el, k) => el.classList.toggle('on', l > 0.06 + k * 0.12));
      E._w.forEach((el, k) => el.classList.toggle('on', l > 0.12 + k * 0.12));
      E._pk.forEach((el, k) => el.classList.toggle('on', l > 0.12 + k * 0.12));
      E.count.textContent = fmt(1284 * seg(l, 0.1, 0.9));
      return -1;
    }

    /* ---------- commerce ---------- */
    function commerce(E, l, t) {
      E.cube.style.transform = `rotateX(-20deg) rotateY(${(l * 360 + t * 0.03).toFixed(1)}deg)`;
      E.prod.style.transform = `translateZ(${(40 + Math.sin(t * 0.001) * 8).toFixed(1)}px) rotateY(${lerp(14, 4, l).toFixed(2)}deg)`;
      E.cart.style.transform = 'translateZ(90px) rotateY(-8deg)';
      E.add.classList.toggle('press', l > 0.18 && l < 0.24);
      E.add.classList.toggle('done', l > 0.24);
      const addTxt = E.add.getAttribute(l > 0.24 ? 'data-b' : 'data-a');
      if (E.add.textContent !== addTxt) E.add.textContent = addTxt;
      const f = seg(l, 0.22, 0.42);
      const fx = lerp(215, 420, f), fy = lerp(275, 45, f) - Math.sin(f * Math.PI) * 90;
      E.fly.style.transform = `translate3d(${fx.toFixed(1)}px,${fy.toFixed(1)}px,140px) scale(${lerp(1, 0.5, f).toFixed(3)}) rotate(${(f * 200).toFixed(1)}deg)`;
      E.fly.style.opacity = f > 0 && f < 1 ? '1' : '0';
      const n = l > 0.42 ? 1 : 0;
      if (n !== E._n) { E._n = n; E.badge.textContent = String(n); E.badge.classList.add('bump'); setTimeout(() => E.badge.classList.remove('bump'), 300); }
      const o = seg(l, 0.48, 0.62);
      E.order.style.opacity = o.toFixed(3);
      E.order.style.transform = `translate3d(0,${(30 * (1 - o)).toFixed(1)}px,${lerp(0, 70, o).toFixed(1)}px) rotateY(-8deg)`;
      const s = seg(l, 0.62, 0.74);
      E.stats.style.opacity = s.toFixed(3);
      E.stats.style.transform = `translate3d(0,${(30 * (1 - s)).toFixed(1)}px,60px)`;
      if (!E._bars) E._bars = [...E.bars.children];
      E._bars.forEach((el, k) => { el.style.transform = `scaleY(${Math.max(0.05, seg(l, 0.66 + k * 0.03, 0.8 + k * 0.03)).toFixed(3)})`; });
      E.rev.textContent = money(18940 * seg(l, 0.66, 0.95));
      return -1;
    }

    const KINDS = { website: [web, WEB_STEPS, [520, 540]], app: [app, APP_STEPS, [520, 540]], automation: [automation, null, [500, 390]], commerce: [commerce, null, [500, 460]] };

    class CFExpertiseScene extends HTMLElement {
      connectedCallback() {
        if (!live(this)) return; // simple déplacement dans l'éditeur
        const def = KINDS[this.getAttribute('data-kind')] || KINDS.commerce;
        [this.fn, this.stepsAt, this.size] = def;
        this.stage = this.querySelector('.cf-exp__stage');
        this.fit = this.querySelector('.cf-exp__fit');
        // mise à l'échelle immédiate (peu coûteuse) : la scène tient dans sa colonne dès l'affichage
        this.ro = new ResizeObserver(() => this.measure());
        this.ro.observe(this.stage);
        this.measure();
        // le reste (défilement, rendu des étapes) à l'approche de l'écran
        this.stopNear = whenNear(this, () => this.init());
      }
      init() {
        this.E = { root: this };
        this.querySelectorAll('[data-el]').forEach((n) => { this.E[n.getAttribute('data-el')] = n; });
        this.btns = [...this.querySelectorAll('.cf-steps5__btn')];
        this.l = 0; this.target = 0; this.manual = null; this.visible = false;
        this.tick = this.tick.bind(this);
        this.classList.add('is-live');
        this.unsub = onScroll(() => this.read());
        this.stopVis = observeVisible(this, (v) => { this.visible = v; this.sync(); if (!v) this.manual = null; });
        this.onMotion = () => { this.pauseSvg(); this.sync(); };
        document.addEventListener('cf:motion-change', this.onMotion);
        if (firstBind(this)) this.btns.forEach((b, i) => b.addEventListener('click', () => {
          if (this.ext) {
            // séquence : l'étape choisie correspond à une position de défilement, gérée par <cf-exp-sequence>
            this.dispatchEvent(new CustomEvent('cf:exp-step', { bubbles: true, detail: { at: this.stepsAt[i] } }));
            track('expertise_step', { kind: this.getAttribute('data-kind'), step: i + 1 });
            return;
          }
          this.manual = this.stepsAt[i];
          this.manualAt = scrollTop();
          if (!this.running) { this.l = this.manual; this.render(performance.now()); }
          track('expertise_step', { kind: this.getAttribute('data-kind'), step: i + 1 });
        }));
        this.pauseSvg();
        this.read();
        this.l = this.target;
        this.render(performance.now());
      }
      disconnectedCallback() {
        release(this, () => {
          if (this.stopNear) this.stopNear();
          loop.remove(this.tick); this.running = false;
          if (this.ro) this.ro.disconnect();
          if (this.unsub) this.unsub();
          if (this.stopVis) this.stopVis();
          document.removeEventListener('cf:motion-change', this.onMotion);
        });
      }
      pauseSvg() {
        this.querySelectorAll('svg').forEach((svg) => {
          if (!svg.pauseAnimations) return;
          if (motion() === 'off') svg.pauseAnimations(); else svg.unpauseAnimations();
        });
      }
      measure() {
        // tailles de mise en page (non affectées par les bascules 3D de la séquence)
        const k = Math.min(1.1, (this.stage.offsetWidth - 16) / this.size[0], (this.stage.offsetHeight - 58) / this.size[1]); // bande basse réservée au label « Démo illustrative »
        this.fit.style.setProperty('--k', Math.max(0.3, k).toFixed(3));
      }
      /* piloté par la séquence : l = avancée dans ce panneau (0 → 1) */
      external(l, active) {
        const same = this.ext && this.active === active && this.target === l;
        this.ext = true;
        this.active = active;
        this.manual = null;
        this.target = l;
        if (!this.E || (same && !active)) return;
        if (!active || !this.running) { this.l = l; this.render(performance.now()); }
      }
      detach() {
        if (!this.ext) return;
        this.ext = false;
        if (this.E) this.read();
      }
      read() {
        if (this.ext || !this.E) return;
        if (this.manual != null && Math.abs(scrollTop() - this.manualAt) > 90) this.manual = null;
        const r = this.stage.getBoundingClientRect();
        const vh = window.innerHeight;
        const startY = vh * 0.95, endY = vh * 0.3;
        const centre = r.top + r.height * 0.5;
        this.target = clamp((startY - centre) / (startY - endY), 0, 1);
        if (!this.running) { this.l = motion() === 'off' ? 1 : this.target; this.render(performance.now()); }
      }
      sync() {
        const anim = this.visible && motion() !== 'off';
        if (anim && !this.running) { this.running = true; loop.add(this.tick); }
        else if (!anim && this.running) { this.running = false; loop.remove(this.tick); }
        if (!anim) this.render(performance.now());
      }
      tick(t) {
        if (this.ext) { if (this.active) { this.l = this.target; this.render(t); } return; } // la séquence lisse déjà l'avancée ; panneaux masqués : pas de rendu
        const goal = this.manual != null ? this.manual : this.target;
        this.l += (goal - this.l) * loop.k(0.1);
        if (Math.abs(goal - this.l) < 0.0005) this.l = goal;
        this.render(t);
      }
      render(t) {
        if (!this.E) return;
        let l = this.l;
        if (motion() === 'off') l = this.manual != null ? this.manual : 1;
        const step = this.fn(this.E, clamp(l, 0, 1), motion() === 'off' ? 0 : t);
        if (step >= 0 && step !== this.step) {
          this.step = step;
          this.btns.forEach((b, k) => {
            b.classList.toggle('is-on', k === step);
            b.classList.toggle('is-done', k < step);
            b.setAttribute('aria-pressed', String(k === step));
          });
        }
      }
    }
    customElements.define('cf-expertise-scene', CFExpertiseScene);

    /* ---------- séquence immersive : une expertise à la fois, pilotée par le défilement ---------- */
    class CFExpSequence extends HTMLElement {
      connectedCallback() {
        if (!live(this)) return;
        this.section = this.closest('.cf-exp');
        this.seqEl = this.closest('.cf-exp__seq');
        this.seq = !!this.section && this.section.classList.contains('cf-exp--seq');
        if (!this.seq) return;
        this.rows = [...this.querySelectorAll('.cf-exp__row')];
        this.scenes = this.rows.map((r) => r.querySelector('cf-expertise-scene'));
        this.dots = [...this.querySelectorAll('.cf-exp__dot')];
        this.now = this.querySelector('[data-now]');
        this.rail = this.querySelector('.cf-exp__rail span');
        this.cat = this.querySelector('[data-cat]');
        this.next = this.querySelector('[data-next]');
        this.skip = this.querySelector('.cf-exp__skip');
        this.n = this.rows.length;
        this.cur = 0; this.target = 0; this.idx = -1; this.visible = false;
        this.tick = this.tick.bind(this);
        this.unsub = onScroll(() => this.read());
        this.stopVis = observeVisible(this, (v) => { this.visible = v; this.sync(); });
        this.onMotion = () => { this.read(); this.cur = this.target; this.sync(); this.apply(performance.now()); };
        document.addEventListener('cf:motion-change', this.onMotion);
        if (firstBind(this)) {
          this.dots.forEach((d, k) => d.addEventListener('click', () => this.goTo(k + 0.55)));
          // mobile : un seul bouton « Suivant », puis « Continuer » sur la dernière expertise
          if (this.next) this.next.addEventListener('click', () => {
            const i = Math.max(0, this.idx);
            if (i < this.n - 1) this.goTo(i + 1 + 0.55);
            else if (this.skip) this.skip.click();
          });
          this.addEventListener('cf:exp-step', (e) => {
            const row = e.target.closest('.cf-exp__row');
            const k = this.rows.indexOf(row);
            if (k >= 0) this.goTo(k + clamp(e.detail.at, 0.02, 0.98));
          });
        }
        this.read();
        this.cur = this.target;
        this.apply(performance.now());
      }
      disconnectedCallback() {
        release(this, () => {
          loop.remove(this.tick); this.running = false;
          if (this.unsub) this.unsub();
          if (this.stopVis) this.stopVis();
          document.removeEventListener('cf:motion-change', this.onMotion);
        });
      }
      on() { return this.seq && !!this.seqEl && motion() !== 'off'; }
      goTo(pos) {
        const sc = scroller();
        const total = this.seqEl.offsetHeight - window.innerHeight;
        const top = sc.scrollTop + this.seqEl.getBoundingClientRect().top + total * (pos / this.n);
        sc.scrollTo({ top, behavior: motion() === 'off' ? 'auto' : 'smooth' });
      }
      read() {
        if (!this.on()) return;
        const r = this.seqEl.getBoundingClientRect();
        const total = this.seqEl.offsetHeight - window.innerHeight;
        this.target = total > 0 ? clamp(-r.top / total, 0, 1) : 0;
        if (!this.running) { this.cur = this.target; this.apply(performance.now()); }
      }
      sync() {
        const anim = this.visible && this.on();
        if (anim && !this.running) { this.running = true; loop.add(this.tick); }
        else if (!anim && this.running) { this.running = false; loop.remove(this.tick); }
        if (!this.on()) this.scenes.forEach((s) => s && s.detach && s.detach());
      }
      tick() {
        this.cur += (this.target - this.cur) * loop.k(0.14);
        if (Math.abs(this.target - this.cur) < 0.00005) this.cur = this.target;
        this.apply();
      }
      apply() {
        if (!this.on()) return;
        const p = this.cur * this.n;
        const i = clamp(Math.floor(p), 0, this.n - 1);
        const l = clamp(p - i, 0, 1);
        if (i !== this.idx) {
          this.idx = i;
          this.rows.forEach((r, k) => { r.classList.toggle('is-active', k === i); r.classList.toggle('is-past', k < i); });
          this.dots.forEach((d, k) => { d.classList.toggle('is-on', k === i); if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
          if (this.now) this.now.textContent = String(i + 1).padStart(2, '0');
          if (this.cat) this.cat.textContent = this.rows[i].getAttribute('data-tag') || '';
          if (this.next) this.next.classList.toggle('is-last', i === this.n - 1);
        }
        // panneau actif : avancée réelle ; voisins : état final ou initial pour des bascules cohérentes
        this.scenes.forEach((s, k) => {
          if (!s || !s.external) return;
          if (k === i) s.external(l, true);
          else if (Math.abs(k - i) === 1) s.external(k < i ? 1 : 0, false);
        });
        if (this.rail) this.rail.style.transform = `scaleX(${this.cur.toFixed(3)})`;
      }
    }
    customElements.define('cf-exp-sequence', CFExpSequence);
  };
  if (window.CF) start(); else document.addEventListener('cf:ready', start, { once: true });
})();
